var map = {
	"./AED.png": 41782,
	"./AUD.png": 94438,
	"./CAD.png": 87108,
	"./CHF.png": 53637,
	"./EUR.png": 93452,
	"./GBP.png": 5609,
	"./INR.png": 55953,
	"./JPY.png": 1923,
	"./MUR.png": 63860,
	"./NZD.png": 33360,
	"./SAR.png": 69874,
	"./SGD.png": 38978,
	"./USD.png": 45164,
	"./india.png": 51421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38088;